import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { SliderComponent } from '../../components/slider/slider.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { ProductSectionComponent } from '../../components/product-section/product-section.component';
import { PromotionSectionComponent } from '../../components/promotion-section/promotion-section.component';
import { RelatedProductComponent } from '../../components/related-product/related-product.component';
import { OffersInfoComponent } from '../../components/offers-info/offers-info.component';
import { loadMercadoPago } from '@mercadopago/sdk-js';
import { MercadoPagoService } from '../../services/mercado-pago.service';
import { BtnWalletComponent } from '../../components/btn-wallet/btn-wallet.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [HeaderComponent,
    SliderComponent,
    FooterComponent,
    RelatedProductComponent,
    ProductSectionComponent,
    PromotionSectionComponent,
    OffersInfoComponent,
    BtnWalletComponent,
    CommonModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  paymentId = '';
  showPayment: boolean = false;
  constructor(private mpService: MercadoPagoService) { }

  async generate() {
   
    let pay = {
      "order": [
        {
          "id": "0001",
          "title": "Test 1",
          "quantity":1,
          "unit_price": 200.00
        }, {
          "id": "0002",
          "title": "Test 2",
          "quantity": 1,
          "unit_price": 100.00
        }, {
          "id": "0003",
          "title": "Test 3",
          "quantity": 1,
          "unit_price": 50
        }
      ]
    };
    
    this.mpService.createOrder(pay).subscribe({
      next: (res:any) => {
      console.log('res :', res);
      this.showPayment = true;
        this.paymentId = res?.id || '';
      }, 
      error: (err: any) => {
        this.showPayment = false;
      console.log('err :', err);

      }
    })
  }
}
